import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root:{
    padding: '15px 0',
    textAlign: 'center'
  }
});

const Unauthorized = (props) => {
  const classes = useStyles(props);
  let errorMsg = "You are not authorized to access this page.";
  if (props.translationsData && props.translationsData.data) {
    errorMsg = props.translationsData.data["SSO_AUTH_ERROR_MSG_"+[`${props.errorCode}`]]
  }

  return(
  
    <Typography align="center" classes={{root: classes.root}}>{errorMsg}</Typography>
    
  );
};

export default Unauthorized;
